import type { User } from ".";

// Variável global para armazenar o usuário atual
let currentUser: User | null = null;

/**
 * Define o usuário atual (chamado pelo ProvedorAutenticacaoJwt)
 */
export function setUserServer(user: User | null) {
	currentUser = user;
}

/**
 * Obtém o usuário autenticado no momento da chamada.
 * Deve ser usado dentro de actions, handlers ou requests, nunca como snapshot no escopo do módulo.
 */
export function getAuthenticatedUserServer(): User {
	if (!currentUser) throw new Error("Usuário não autenticado.");

	return currentUser;
}
